<template>
  <div class="pt-3">
    <select-course />
    <my-calendar id="calendar" key="calendar" class="col-12 col-lg-8" />
    <v-dialog
      v-model="toggleAddEvent"
      :fullscreen="isMobile"
      persistent
      no-click-animation
      transition="fade-transition"
      content-class="add-event-modal"
      :max-width="isMobile ? '':'400px'"
    >
      <v-card
        color="background"
        flat
        class="add-event-modal-card p-3"
        :class="{'rounded': !isMobile}"
      >
        <add-event @cancelEdit="closeAddEventDialog" />
      </v-card>
    </v-dialog>
    <v-btn @click="addEventToCalendar()" id="add-event-to-calendar" fab fixed right color="#eee">
      <v-icon large>add</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import MyCalendar from "@/components/Calendar/MyCalendar";
import SelectCourse from "@/components/Calendar/SelectCourse";
import AddEvent from "./AddEvent";
import $ from "jquery";
import { get } from "@/utils";

@Component({
  components: {
    MyCalendar,
    AddEvent,
    SelectCourse
  }
})
export default class CalendarPage extends Vue {
  get toggleAddEvent() {
    return this.$store.state.calendar.showAddEventDialog
  }

  get isMobile() {
    return this.$store.state.isMobile;
  }

  get user() {
    return this.$store.state.user.loggedInUser;
  }

  addEventToCalendar() {
    this.$store.commit("calendar/resetEditEvent");
    this.$store.commit("calendar/toggleAddEventDialog", true);
  }

  closeAddEventDialog() {
    this.$store.commit("calendar/toggleAddEventDialog", false);
    if (this.isMobile) $("#nav").removeClass("sticky");
  }

  async created() {
    $(document).on("keyup", e => {
      if (e.key === "Escape") {
        this.$store.commit("calendar/toggleAddEventDialog", false);
      }
    });

    this.getEvents();
  }

  @Watch("$store.state.calendar.selected", { deep: true })
  watchSelected(val) {
    this.getEvents(val);
  }

  @Watch("$store.state.user.loggedInUser")
  async watchLoggedInUser() {
    this.getEvents(this.$store.state.calendar.selected);
  }

  getEvents(filters) {
    if (!this.user) {
      this.$store.commit("calendar/setEvents", []);
      return;
    }

    clearTimeout(this.throttleGetEvents);
    this.throttleGetEvents = setTimeout(() => {
      this.getEventsAfterThrottle(filters);
    }, 250)
  }

  async getEventsAfterThrottle(filters = {}) {
    const f = {}
    filters.schools && filters.schools.length && (f.schools = filters.schools.map(s => s.slug));
    filters.klasses && filters.klasses.length && (f.klasses = filters.klasses.map(s => s.slug));
    filters.courses && filters.courses.length && (f.courses = filters.courses.map(s => s.slug));

    const hasMe = (e, id) => !!e.users.find(u => u.id == id);
    const isCreator = (e, id) => !!e.creators.find(u => u.id == id);
    const isCreatorStudent = (e) => !!e.creators.find(u => u.roles.includes('student'));
    const hasAnotherTeacher = (e) => !!e.users.find(u => !u.roles.includes('student'));
    const isPrivateMeeting = (e) => e.users.length && !e.schools.length && !e.klasses.length && !e.courses.length;

    let events = [];
    if (Object.keys(f).length || !filters.personnel || !filters.personnel.length) {
      events = await get("/api/getFilteredEvents", f);
      if (this.$store.getters.isAdmin) {
        events = events.filter(e => !isCreatorStudent(e) && !isPrivateMeeting(e));
      }
    }

    for (let personnel of (filters.personnel || [] )) {
      let myEvents = await get("/api/getMyEvents", { userId: personnel.id});

      if (this.$store.getters.isAdmin) {
        myEvents = myEvents.filter(e => hasMe(e, personnel.id) || !isCreator(e, personnel.id) || !hasAnotherTeacher(e));
      }
      events = events.concat(myEvents);
    }

    let eventsById = {};
    for (let e of events) {
      if (!eventsById[e.id]) {
        eventsById[e.id] = [e];
      } else {
        Object.assign(eventsById[e.id], e);
      }
    }

    events = Object.values(eventsById).flat();

    this.$store.commit("calendar/setEvents", events);
  }

  beforeDestroy() {
    $(document).unbind("keyup");
  }
}
</script>

<style lang="scss">
.add-event-modal {
  overflow-x: hidden;
}
#calendar {
  height: 50vh !important;
}
#add-event-to-calendar {
  bottom: 15px;
  z-index: 20;
}
.mobile {
  .add-event-modal {
    .add-event-modal-card {
      padding: 0 15px !important;
    }
  }
}
@media screen and (min-width: 900px) {
  #add-event-to-calendar {
    right: 20vw;
  }
}
</style>
